// components/ProtectedRoute.jsx (DEMO)

import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const access = useSelector((s) => s.access);

  const loaded = access?.loaded;
  const hasUser = access?.hasUser;

  // Wait until we know if there is a demo user
  if (!loaded) {
    return null; // or a spinner
  }

  // No demo user -> force back to landing
  if (!hasUser) {
    return <Navigate to="/" replace />;
  }

  // Demo user exists -> allow access
  return children;
};

export default ProtectedRoute;